var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ag-grid__overlay-form-box" }, [
    _c("div", { staticClass: "ag-grid__overlay-form-box-title" }, [
      _vm._v("\n    Block Numbers\n  ")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "p-15" },
      [
        _c("ValidationObserver", {
          ref: "formValidation",
          attrs: { slim: "" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function({ invalid }) {
                return [
                  _c(
                    "div",
                    { staticClass: "col-md-offset-3" },
                    [
                      _c("BulkCallDetails", {
                        key: _vm.bulkCallReviewKey,
                        attrs: { "selected-calls": _vm.selectedCalls },
                        on: {
                          unselectCallOnBulkAction: _vm.unselectCallOnBulkAction
                        }
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "m-t-10 text-muted" }, [
                        _c("strong", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("NOTE_BULK_BLOCK_NUMBER")) +
                              "\n          "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "form",
                        { staticClass: "form-horizontal m-t-20" },
                        [
                          _c(
                            "BaseFormField",
                            {
                              staticClass: "form-group",
                              attrs: {
                                label: _vm.$t("SPECIFY_DURATION_LABEL"),
                                "tooltip-text": _vm.$t("SPECIFY_DURATION_TT"),
                                "has-tooltip": ""
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "col-md-2" },
                                [
                                  _c("ValidationProvider", {
                                    attrs: { rules: "min_value:1", slim: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({ classes }) {
                                            return [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.expInHour,
                                                    expression: "expInHour"
                                                  }
                                                ],
                                                staticClass:
                                                  "form-control m-b-0",
                                                class: classes,
                                                attrs: {
                                                  name: "timePeriod",
                                                  type: "number",
                                                  min: "1",
                                                  placeholder: _vm.$t(
                                                    "DURATION_HOURS_UNIT"
                                                  )
                                                },
                                                domProps: {
                                                  value: _vm.expInHour
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.expInHour =
                                                      $event.target.value
                                                  }
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "BaseFormField",
                            {
                              staticClass: "form-group",
                              attrs: {
                                label: _vm.$t("BLOCK_ACCOUNT_WIDE_LABEL"),
                                "tooltip-text": _vm.$t("BLOCK_ACCOUNT_WIDE_TT"),
                                "has-tooltip": ""
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "col-md-3" },
                                [
                                  _c("NzToggle", {
                                    model: {
                                      value: _vm.blockAccountWide,
                                      callback: function($$v) {
                                        _vm.blockAccountWide = $$v
                                      },
                                      expression: "blockAccountWide"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "PrimaryButton",
                            {
                              staticClass: "m-t-15",
                              attrs: {
                                size: "sm",
                                disabled: invalid,
                                "show-loader-on-form": _vm.showLoader
                              },
                              on: { click: _vm.handleBlockNumbers }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("BLOCK_NUMBERS")) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("button", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "CANCEL",
                                expression: "'CANCEL'"
                              }
                            ],
                            staticClass: "btn btn-danger btn-sm m-t-15 m-l-10",
                            on: { click: _vm.hideBulkForm }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }